import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { Link } from 'react-router-dom';

import { Tooltip } from '@dndbeyond/character-common-components/es';
import {
    CampaignSummary,
    LightBuilderSvg,
    ThemedShareSvg,
    ThemedLongRestSvg,
    ThemedShortRestSvg,
} from '@dndbeyond/character-components/es';
import {
    characterActions,
    CampaignDataContract,
    CharacterPreferences,
    CharacterTheme,
    Constants,
    HitPointInfo,
    Item,
    ItemUtils,
    RuleData,
    rulesEngineSelectors,
} from '@dndbeyond/character-rules-engine/es';

import { sidebarActions } from '../../../Shared/actions';
import { appEnvSelectors } from '../../../Shared/selectors';
import { PaneComponentEnum } from '../../../Shared/utils';
import { sheetActions } from '../../actions/sheet';
import StatusSummaryMobile from '../../components/StatusSummaryMobile';
import { sheetAppSelectors } from '../../selectors';
import { SheetAppState } from '../../typings';
import { CharacterHeaderInfo } from '../CharacterHeaderInfo';

interface Props extends DispatchProp {
    hitPointInfo: HitPointInfo;
    fails: number;
    successes: number;
    deathCause: Constants.DeathCauseEnum;
    inspiration: boolean;
    campaign: CampaignDataContract | null;
    builderUrl: string;
    items: Array<Item>;
    preferences: CharacterPreferences;
    ruleData: RuleData;
    isReadonly: boolean;
    theme: CharacterTheme;
}
class CharacterHeaderTablet extends React.PureComponent<Props> {
    handleCampaignShow = (): void => {
        const { dispatch } = this.props;
        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.CAMPAIGN));
    };

    handleShortResetClick = (evt: React.MouseEvent): void => {
        const { dispatch } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.SHORT_REST));
    };

    handleGameLogClick = (evt: React.MouseEvent): void => {
        const { dispatch } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.GAME_LOG));
    };

    handleLongResetClick = (evt: React.MouseEvent): void => {
        const { dispatch } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.LONG_REST));
    };

    handleShareClick = (evt: React.MouseEvent): void => {
        const { dispatch } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        dispatch(sheetActions.shareUrl());
    };

    handleHealthSummaryClick = (): void => {
        const { dispatch, isReadonly } = this.props;

        if (!isReadonly) {
            dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.HEALTH_MANAGE));
        }
    };

    handleInspirationClick = (): void => {
        const { inspiration, dispatch } = this.props;

        dispatch(characterActions.inspirationSet(!inspiration));
    };

    hasMagicItem = (): boolean => {
        const { items } = this.props;

        return !!items.find((item) => ItemUtils.isMagic(item));
    };

    renderSideContent = (): React.ReactNode => {
        const {
            hitPointInfo,
            fails,
            successes,
            deathCause,
            inspiration,
            builderUrl,
            campaign,
            preferences,
            isReadonly,
            ruleData,
            theme,
        } = this.props;

        if (isReadonly) {
            return (
                <React.Fragment>
                    {campaign !== null && (
                        <div className="ct-character-header-tablet__group ct-character-header-tablet__group--campaign">
                            <CampaignSummary campaign={campaign} onCampaignShow={this.handleCampaignShow} />
                        </div>
                    )}
                    <div className="ct-character-header-tablet__group ct-character-header-tablet__group--summary">
                        <StatusSummaryMobile
                            hitPointInfo={hitPointInfo}
                            fails={fails}
                            successes={successes}
                            inspiration={inspiration}
                            ruleData={ruleData}
                            deathCause={deathCause}
                            onHealthClick={this.handleHealthSummaryClick}
                            onInspirationClick={this.handleInspirationClick}
                        />
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {preferences !== null && preferences.privacyType === Constants.PreferencePrivacyTypeEnum.PUBLIC && (
                    <div className="ct-character-header-tablet__group ct-character-header-tablet__group--share">
                        <div className="ct-character-header-tablet__button" onClick={this.handleShareClick}>
                            <div className="ct-character-header-tablet__button-icon">
                                <ThemedShareSvg theme={theme} />
                            </div>
                            <span className="ct-character-header-tablet__button-label">Share</span>
                        </div>
                    </div>
                )}
                <div className="ct-character-header-tablet__group ct-character-header-tablet__group--short-rest">
                    <div className="ct-character-header-tablet__button" onClick={this.handleShortResetClick}>
                        <div className="ct-character-header-tablet__button-icon">
                            <ThemedShortRestSvg theme={theme} />
                        </div>
                        <span className="ct-character-header-tablet__button-label">Short Rest</span>
                    </div>
                </div>
                <div className="ct-character-header-tablet__group ct-character-header-tablet__group--long-rest">
                    <div className="ct-character-header-tablet__button" onClick={this.handleLongResetClick}>
                        <div className="ct-character-header-tablet__button-icon">
                            <ThemedLongRestSvg theme={theme} />
                        </div>
                        <span className="ct-character-header-tablet__button-label">Long Rest</span>
                    </div>
                </div>
                {/*{this.hasMagicItem() &&*/}
                {/*<div className="ct-character-header-tablet__group">*/}
                {/*<div className="ct-character-header-tablet__button" onClick={this.handleDawnClick}>*/}
                {/*<i className="i-menu-dawn" />*/}
                {/*<span className="ct-character-header-tablet__button-label">Dawn</span>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*}*/}
                {campaign !== null && (
                    <div className="ct-character-header-tablet__group ct-character-header-tablet__group--campaign">
                        <CampaignSummary campaign={campaign} onCampaignShow={this.handleCampaignShow} />
                    </div>
                )}
                <div className="ct-character-header-tablet__group ct-character-header-tablet__group--builder">
                    <Tooltip
                        isDarkMode={theme.isDarkMode}
                        title="Go to builder"
                        className="ct-character-header-tablet__builder"
                    >
                        <Link to={builderUrl} className="ct-character-header-tablet__builder-link">
                            <LightBuilderSvg />
                        </Link>
                    </Tooltip>
                </div>
                <div className="ct-character-header-tablet__group ct-character-header-tablet__group--summary">
                    <StatusSummaryMobile
                        hitPointInfo={hitPointInfo}
                        fails={fails}
                        successes={successes}
                        deathCause={deathCause}
                        inspiration={inspiration}
                        ruleData={ruleData}
                        onHealthClick={this.handleHealthSummaryClick}
                        onInspirationClick={this.handleInspirationClick}
                        isInteractive={!isReadonly}
                    />
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <div className="ct-character-header-tablet">
                <div className="ct-character-header-tablet__group ct-character-header-tablet__group-tidbits">
                    <CharacterHeaderInfo />
                </div>
                <div className="ct-character-header-tablet__group ct-character-header-tablet__group--gap" />
                {this.renderSideContent()}
            </div>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        hitPointInfo: rulesEngineSelectors.getHitPointInfo(state),
        fails: rulesEngineSelectors.getDeathSavesFailCount(state),
        successes: rulesEngineSelectors.getDeathSavesSuccessCount(state),
        inspiration: rulesEngineSelectors.getInspiration(state),
        builderUrl: sheetAppSelectors.getBuilderUrl(state),
        campaign: rulesEngineSelectors.getCampaign(state),
        items: rulesEngineSelectors.getInventory(state),
        preferences: rulesEngineSelectors.getCharacterPreferences(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
        ruleData: rulesEngineSelectors.getRuleData(state),
        deathCause: rulesEngineSelectors.getDeathCause(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
    };
}

export default connect(mapStateToProps)(CharacterHeaderTablet);
